import { setShowSelectItemDescriptionModal } from '../../../State/showSelectItemDescriptionModal';
import { setCurrentEstimateItem } from '../../../State/currentEstimateItem';

export default ({ estimateGroupIndex, estimateItemIndex }) => async (dispatch) => {
  
  dispatch(setCurrentEstimateItem({ estimateGroupIndex, estimateItemIndex }));
  dispatch(setShowSelectItemDescriptionModal(true));

}